import React, { useContext } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import AppContext from '../state/App.context';
import { Menu } from '../components/Menu';
// import './Base.css';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props}/>;
});

function Base({ children }) {
  const [snack, setSnack] = useContext(AppContext).snackState;
  const showMenu = window.location.pathname !== '/maintenance';

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    };
    setSnack({
      ...snack,
      open: false
    });
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection:'row',
      alignItems:'center',
      justifyContent:'space-between',
      width: '100%',
      position: 'relative',
      overflow: 'hidden' }}>
      {showMenu && <Menu></Menu>}
      {children}
      <Snackbar
        open={snack.open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleClose} severity={snack.severity}>
          {snack.message}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Base;
